import { Component, OnInit } from '@angular/core';
import { CommonUtilitiesService } from "../common-utilities.service";
import { constants } from "../constants";
//jquery var
import * as $ from 'jquery';
declare var $: any;
@Component({
  selector: 'app-homologation',
  templateUrl: './homologation.component.html',
  styleUrls: ['./homologation.component.scss']
})
export class HomologationComponent implements OnInit {

  constructor(public LANG:CommonUtilitiesService) { }

  ngOnInit() {
    $("html, body").animate({ scrollTop: 0 }, "slow");
  }

  openPdf(){
    window.open(constants.URL_PDF_REGULATIONS_HOMOLOGATION_1, '_blank')
  }
  openPdf2(){
    window.open(constants.URL_PDF_REGULATIONS_HOMOLOGATION_2, '_blank')
  }

}
